import React from 'react';
import useAppSelector from '../../app/redux/useAppSelector';
import SVGIcon from '../../components/SVGIcon';
import { gql } from '../../graphql/generated/gql';
import commentIcon from '../../icons/non-prefilled/16x16/comment.svg';
import type { ExtractCommentThreadTypes } from '../../utils/post/threadUtils';
import {
  PostLayoutSize,
  useIsPostLayoutSize,
} from '../../utils/responsive/PostLayoutSizeProvider';
import { COMMENT_THREAD_CREATION_ID } from '../PendingMagneticWallItemProvider';
import * as styles from './CommentThreadCompact.module.scss';
import CommentThreadCompactAvatar from './CommentThreadCompactAvatar';
import CommentThreadCompactAvatarStack from './CommentThreadCompactAvatarStack';

const THREAD_FRAGMENT = gql(`
  fragment CommentThreadCompact_thread on RootThreadFields {
    id
    ... on CommentThread {
      comments {
        id
        author {
          id
          ...CommentThreadCompactAvatar_user
        }
      }
    }
    ... on PublicCommentThread {
      comments {
        id
        author {
          id
          ...CommentThreadCompactAvatar_user
        }
      }
    }
  }
`);

interface CommentThreadCompactProps {
  thread: ExtractCommentThreadTypes<typeof THREAD_FRAGMENT>;
}

const CommentThreadCompact = ({ thread }: CommentThreadCompactProps) => {
  const isTablet = useIsPostLayoutSize(PostLayoutSize.tablet);
  const currentUser = useAppSelector((state) => state.session.user);

  const avatarStackItems =
    thread.id === COMMENT_THREAD_CREATION_ID
      ? [{ id: currentUser.id, author: currentUser }]
      : thread.comments;

  if (isTablet) {
    return (
      <SVGIcon size={16} className={styles.icon}>
        {commentIcon}
      </SVGIcon>
    );
  }

  return (
    <CommentThreadCompactAvatarStack items={avatarStackItems}>
      {(item) => <CommentThreadCompactAvatar user={item.author} />}
    </CommentThreadCompactAvatarStack>
  );
};

export default CommentThreadCompact;
